import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";

interface SortableTableHeadProps {
  children: React.ReactNode;
  sortKey: string;
  currentSortKey?: string;
  sortDirection?: "asc" | "desc";
  onSort: (sortKey: string) => void;
  className?: string;
}

export function SortableTableHead({
  children,
  sortKey,
  currentSortKey,
  sortDirection,
  onSort,
  className
}: SortableTableHeadProps) {
  const isActive = currentSortKey === sortKey;
  
  return (
    <TableHead 
      className={cn(
        "cursor-pointer hover:bg-muted/20 transition-colors select-none",
        className
      )}
      onClick={() => onSort(sortKey)}
    >
      <div className="flex items-center">
        {children}
        {isActive && (
          <span className="ml-1 text-xs">
            {sortDirection === "asc" ? "↑" : "↓"}
          </span>
        )}
      </div>
    </TableHead>
  );
}